export const AdminTabs = {
    users: 1,
    systems: 2,
};
